import { Injectable } from '@angular/core';
import { PlatformContextService } from './context/platform-context.service';
import { UserStorageService } from './storage/user-storage.service';
import { Config } from './config.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { EnvironnementProvider } from '../../core/app/environnement-provider.service';
import OneSignal from '../../../plugins/onesignal-cordova-plugin';

@Injectable()
export class PushService {

  public notificationReceived: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private platformContextService: PlatformContextService,
    private userStorageService: UserStorageService,
    private readonly config: Config,
    private environnementProvider: EnvironnementProvider,
  ) {
  }

  init() {
    if (!(<any>window).cordova) {
      return;
    }

    OneSignal.setAppId(this.config.getConfig('notifications').onesignal_app_id);
    OneSignal.setNotificationOpenedHandler(jsonData => {
      console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
      this.onPushOpened(jsonData);
    });

    // Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
      console.log('User accepted notifications: ' + accepted);
    });


    /*
    // Ajouter le OneSignalAppID et le Firebase SenderID en config
    this.oneSignal.startInit(
      this.config.getConfig('notifications').onesignal_app_id,
      this.config.getConfig('notifications').google_project_number
    );

    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
    this.oneSignal.handleNotificationReceived().subscribe(data => this.onPushReceived(data.payload));
    this.oneSignal.handleNotificationOpened().subscribe(data => this.onPushOpened(data.notification.payload));
    this.oneSignal.endInit();


    this.oneSignal.addSubscriptionObserver().subscribe(data => {
      window['plugins'].OneSignal.setExternalUserId(this.userStorageService.get().id.toString());
    });
    */

    window['plugins'].OneSignal.setExternalUserId(this.userStorageService.get().id.toString());
    window['plugins'].OneSignal.sendTag('env', this.environnementProvider.defaultName());

  }

  cleanExternalUserId(): void {
    if (!(<any>window).cordova) {
      return;
    }
    if (this.platformContextService.isSalarie()) {
      window['plugins'].OneSignal.removeExternalUserId();
    }
  }

  private onPushReceived(payload: any) {
    console.log('Push received:', payload);
  }

  private onPushOpened(payload: any) {
    console.log('Push opened:', payload);
    if (payload.notification.additionalData && payload.notification.additionalData.blog_article_id) {
      this.notificationReceived.next(payload.notification.additionalData.blog_article_id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/push.service.ts